import { useState } from "react";
import { GLOBAL_IMAGES } from "../../assets/asset";
import Header from "./Header";
import TabSwitcher from "./TabSwitch";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api/axiosInstance";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function Leaderboard() {
  const { user } = useSelector((state) => state.user);
  const rankQuery = useQuery({
    queryKey: ["rankpage"],
    queryFn: async () => await axiosInstance.get("api/rankpagedetail"),
  });
  const [activeTab, setActiveTab] = useState("tab1");

  const getLeaderboardData = () => {
    if (!rankQuery.data?.data) return [];

    if (activeTab === "tab1") {
      return rankQuery.data.data.userdata || [];
    } else {
      return rankQuery.data.data.monthly || [];
    }
  };

  const getTabLabel = () => {
    return activeTab === "tab1" ? "Weekly Rankings" : "Monthly Rankings";
  };

  return (
    <div
      className="min-h-screen pb-5 flex flex-col items-center bg-blue-50 font-mali"
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      role="main"
      aria-labelledby="years-dashboard-title"
    >
      <Header />
      <h2 className="text-4xl mt-5 font-bold">Leadership Board</h2>
      <TabSwitcher activeTab={activeTab} setActiveTab={setActiveTab} />

      <div className="flex items-center my-5 gap-2">
        <img src={user?.profilephotos} className="h-20" alt="" />
        <div className="">
          <p className="font-bold">{user?.user_name}</p>
          <p>{user?.year}</p>
        </div>
      </div>

      {rankQuery.isPending ? (
        <div className="flex items-center justify-center h-screen w-screen ">
          <Loader2 className="h-12 w-12 animate-spin text-gray-600" />
        </div>
      ) : (
        <div className="grid grid-cols-2 h-80 w-full max-w-5xl grid-rows-1 gap-4">
          <div className="bg-white/60 overflow-auto border-4 border-white rounded-2xl p-4">
            <div className="mb-4 pb-2 border-b border-gray-300">
              <h3 className="text-xl font-bold text-gray-800">
                {getTabLabel()}
              </h3>
            </div>

            {getLeaderboardData().map((item, idx) => (
              <div
                key={`${activeTab}-${item.userid}-${idx}`}
                className="flex justify-between border-b-[1px] border-black/10 py-3 items-center"
              >
                <div className="flex items-center gap-10">
                  <img
                    src={
                      item.profilephotos !== "1"
                        ? item.profilephotos
                        : GLOBAL_IMAGES.avatar
                    }
                    className="h-14 w-14 rounded-full object-cover"
                    alt={`${item.user_name} profile`}
                  />

                  <div className="flex items-center justify-center w-8 h-8">
                    <p className="font-bold text-lg">{item.rank}</p>
                  </div>
                </div>

                <div className="text-right">
                  <p className="font-semibold text-lg">{item.user_name}</p>
                  <p className="text-sm text-gray-600">{item.points} points</p>
                </div>
              </div>
            ))}

            {getLeaderboardData().length === 0 && (
              <div className="text-center py-8 text-gray-500">
                <p>
                  No {activeTab === "tab1" ? "weekly" : "monthly"} rankings
                  available
                </p>
              </div>
            )}
          </div>

          <Link to={`/report/badges`} className="h-full">
            <div className="bg-white/60 border-4 border-white rounded-2xl p-4 h-full overflow-auto cursor-pointer hover:bg-white/70 transition-colors">
              <div className="flex justify-between items-center mb-4">
                <h1 className="text-xl font-bold text-gray-800">Badges</h1>
                <h1 className="text-sm text-blue-600 hover:text-blue-800 font-medium">
                  See all
                </h1>
              </div>

              <div className="flex flex-wrap gap-3 justify-start">
                {rankQuery.data?.data?.data?.map((item, idx) => (
                  <div key={idx} className="">
                    <img
                      src={item}
                      className="h-24 w-24 object-contain transition-shadow"
                      alt={`Badge ${idx + 1}`}
                    />
                  </div>
                ))}
              </div>

              {(!rankQuery.data?.data?.data ||
                rankQuery.data.data.data.length === 0) && (
                <div className="text-center py-8 text-gray-500">
                  <p>No badges available</p>
                </div>
              )}
            </div>
          </Link>
        </div>
      )}
    </div>
  );
}
